export default class TileLayout {
  /**
   * Create new layout
   * @param {Array<Number>} counts list of area size, count or amount. list will be sort automatically. e.g. [3, 2, 1]
   * @param {Number} lowerLimit 0 - 100 and lower < upper
   * @param {Number} upperLimit 0 - 100 and lower < upper
   * @param {Number} aspRate width / height rate of plot area. This value will be used to decide separating direction
   */
  constructor (counts = [], lowerLimit = 45, upperLimit = 70, aspRate = 1) {
    this.counts = counts.sort((a, b) => b - a)
    this.lowerLimit = lowerLimit
    this.upperLimit = upperLimit
    this.aspRate = aspRate
    this._arrange()
    this._layout()
  }

  _arrange () {
    const branch = (arr) => {
      const sum = arr.reduce((p, c) => p + c)
      const localLower = this.lowerLimit * sum / 100
      const localUpper = this.upperLimit * sum / 100
      let currentSum = 0
      let breakIndex = 0
      let breakRate = 0
      for (let i = 0; i < arr.length; i++) {
        const passLower = currentSum >= localLower
        const willPassUpper = currentSum + arr[i] > localUpper
        if (passLower && willPassUpper) {
          breakIndex = i
          breakRate = currentSum / sum
          break
        } else if (willPassUpper) {
          breakIndex = i + 1
          breakRate = (currentSum + arr[i]) / sum
          break
        }
        currentSum = currentSum + arr[i]
      }
      if (breakIndex === 0 || breakIndex === arr.length) {
        return arr // no need to split
      } else {
        const left = branch(arr.splice(0, breakIndex))
        const right = branch(arr)
        return [left, right, breakRate]
      }
    }
    this._tree = branch(this.percentages)
  }

  _layout () {
    if (!this.tree) { return }
    const layoutArr = []
    const layoutBranch = (tree, {left, top, width, height}, isHor) => {
      isHor = width * this.aspRate > height
      const breakRate = tree[2]
      const box1 = { // left hand of tree
        left,
        top,
        width: !isHor ? width : width * breakRate,
        height: isHor ? height : height * breakRate
      }
      const box2 = { // right hand of tree
        left: isHor ? left + box1.width : left,
        top: !isHor ? top + box1.height : top,
        width: !isHor ? width : width * (1 - breakRate),
        height: isHor ? height : height * (1 - breakRate)
      }
      const leftHand = tree[0]
      if (leftHand.length >= 2) {
        layoutBranch(leftHand, box1, !isHor)
      } else {
        layoutArr.push(box1)
      }
      const rightHand = tree[1]
      if (rightHand.length >= 2) {
        layoutBranch(rightHand, box2, !isHor)
      } else {
        layoutArr.push(box2)
      }
    }
    layoutBranch(this.tree, {left: 0, top: 0, width: 100, height: 100}, true)
    this._layoutArr = layoutArr
  }

  get percentages () {
    const sum = this.counts.reduce((p, c) => p + (c || 0))
    return this.counts.map(v => (v || 0) * 100 / sum)
  }
  get tree () {
    return this._tree
  }
  get layout () {
    return this._layoutArr
  }
}



// WEBPACK FOOTER //
// ./src/logic/TileLayout.js